import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {MegaHeaderModuleStore} from "./mega-header-module.store";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {MegaHeaderModuleConfig} from "./mega-header-module.config";
import {MegaHeaderModuleHandlers} from "./handlers/mega-header-module.handlers";

export class MegaHeaderModuleController extends ModuleController {
  store: MegaHeaderModuleStore;

  static injectables = [...BaseManagedService.injectables, MegaHeaderModuleConfig, MegaHeaderModuleStore, MegaHeaderModuleHandlers];
}

